/** Phase 18 — invoicePayments lesen. */

import { listAggregateInvoicePayments } from '../infrastructure/storage/domainAggregateStore';
import { listEntityInvoicePayments } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'invoicePayments',
  listAggregate: listAggregateInvoicePayments,
  listEntity: listEntityInvoicePayments,
  idKeys: ['id', 'paymentId']
});

export const readInvoicePaymentsFromMergedBlob = source.readFromMergedBlob;
export const readInvoicePaymentsFromBestSource = source.readFromBestSource;
export const refreshInvoicePaymentsReadCache = source.refreshReadCache;
export const getCachedInvoicePaymentsRead = source.getCachedRead;
export const clearInvoicePaymentsReadCache = source.clearReadCache;
export const readInvoicePaymentsSyncForBusiness = source.readSyncForBusiness;
